/** @format */

import {HotspotKey} from '../../../types';

export const HOTSPOT_HEADERS: Record<HotspotKey, string> = {
  mediaplan: 'Медиаплан',
  funnel: 'Воронка',
  feeds: 'Фиды',
  sensors: 'Сенсоры',
};
